import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";

export default class PageImageSplash extends Component {
	
	
  		
	render() {
		
		let block = this.props.block;
				
		if (block.srcset) {

			return (				
				
				<div className={'c-page__block c-page__block--splash c-page__block--space-' + block.space_after}>
					<div className={'c-image-splash'}>
						<div className="c-image-splash__media">
							<FadeIn>
								{onload => (
									<img
										alt={''} 
										src={block.src} 
										srcSet={block.srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						</div>
						<div className="c-image-splash__inner">
							<h2 className="c-image-splash__heading" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
							<p className="c-image-splash__location" dangerouslySetInnerHTML={{__html:block.location}}></p>
							<p className="c-image-splash__season" dangerouslySetInnerHTML={{__html:block.season}}></p>
							<p className="c-image-splash__time" dangerouslySetInnerHTML={{__html:block.time}}></p>
						</div>
					</div>
				</div>
									
			);
			
		} else {
			return null;
		}
	}
}